// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"94":"Login","308":"MyProfile","318":"Page404","848":"Register"}[chunkId] || chunkId) + "." + {"94":"59a6a84d","113":"b5fb53bc","308":"d230c05c","318":"55e3e78a","646":"c32356cf","848":"7b0ef908","899":"7432363c"}[chunkId] + ".chunk.js";
};